<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">

            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-primary cursor-pointer" @click="openUpdateCategory">
                </feather-icon>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn mt-3"
                              svg-classes="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteCategory">
                </feather-icon>
            </vx-tooltip>
        </div>
        <vs-popup title="Cập nhật danh mục" :active.sync="popupActiveUse">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <label class="vs-input--label required">{{ $t('multipleChoice.category') }}</label>
                        <vs-input class="w-full" v-model="category.categoryName" type="text"
                            data-vv-validate-on="blur" v-validate="'required'" name="category"/>
                            <span class="text-danger text-sm">{{ errors.first('category') }}</span>
                    </div>
                </div>
                <div class="vx-row mt-2">
                    <div class="vx-col w-full">
                        <label class="vs-input--label required">{{ $t('multipleChoice.subject') }}</label>
                        <vs-input class="w-full" v-model="category.subject" type="text" data-vv-validate-on="blur"  v-validate="'required'" name="subject"/>
                        <span class="text-danger text-sm">{{ errors.first('subject') }}</span>
                    </div>
                </div>
                <div class="vx-row mt-2">
                    <div class="vx-col w-full">
                        <label class="vs-input--label required">{{ $t('multipleChoice.grade') }}</label>
                        <vs-input class="w-full" v-model="category.grade" type="text" data-vv-validate-on="blur"  v-validate="'required'" name="grade"/>
                        <span class="text-danger text-sm">{{ errors.first('grade') }}</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full flex flex-wrap mt-4">
                        <div class="flex justify-center upload">
                            <div class="file-upload" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                                <input ref="file" type="file" id="imageUpload" multiple class="hidden"
                                    @change="uploadFile()">
                                <div class="mx-auto">
                                    <div class="text-center">
                                        <feather-icon icon="UploadCloudIcon" svgClasses="h-10 w-10 text-primary" />
                                    </div>
                                    <div class="text-center button-upload">
                                        <vs-button @click="$refs.file.click()">{{ $t('multipleChoice.upload')
                                            }}</vs-button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <label class="file-label text-primary">
                                            <div v-if="isDragging">{{ $t('multipleChoice.isDragging') }}</div>
                                            <div v-else>{{ $t('multipleChoice.outDragging') }}</div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-files mt-2 ml-8">
                            <vs-table stripe :data="files"
                                noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <vs-th>
                                        {{ $t('multipleChoice.name') }}
                                    </vs-th>
                                </template>

                                <template >
                                    <vs-tr >
                                        <vs-td class="text-primary">
                                            {{ files.name }}
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-2">
                    <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                        <vs-button class="float-right mr-5" @click="updateCategory">{{ $t('multipleChoice.updated') }}
                        </vs-button>
                    </div>
                </div>
            </div>
            </vs-popup>
    </div>
</template>
<script>
export default {
    name:'CellRendererActions',
    data() {
        return {
            popupActiveUse:false,
            category: {
                categoryName: null,
                subject: null,
                grade: null,
                fileId: null,
            },
            files: [],
            filesId: [],
            isDragging: false,
        }
    },
    methods:{
           dragover(e) {
            e.preventDefault()
            this.isDragging = true
        },
        dragleave() {
            this.isDragging = false
        },
        drop(e) {
            e.preventDefault()
            this.$refs.file.files = e.dataTransfer.files
            this.uploadFile()
            this.isDragging = false
        },

        uploadFile() {
            let file = this.$refs.file.files[0]
            this.files = file;
            this.$refs.file.value = null
        },
        handleClickUploadFile() {
            return new Promise((resolve) => {
                let formData = new FormData(), config = {};
                    formData.append('files', this.files);
                config = {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                };

                this.$vs.loading();
                let url = `/school-quiz-category/upload-file-category`
                this.$crm.post(url, formData, config).then((res) => {
                    this.filesId = [];
                    res.data.fileManager.map(el => {
                        this.filesId.push(el.id)
                    });
                    resolve(true);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            });
        },
        openUpdateCategory(){
            this.category.categoryName = this.params.data.categoryName;
            this.category.subject = this.params.data.subject;
            this.category.grade = this.params.data.grade;
            this.params.data.fileManagers.map(el => {
                this.files = el
            }),
            this.popupActiveUse = true;
        },
        async updateCategory(){
            if(!this.category.categoryName || !this.category.subject || !this.category.grade){
                return this.$vs.notify({
                    text: 'Vui lòng nhập đầy đủ thông tin',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                })
            }
            if (this.files) {
                await this.handleClickUploadFile();
            }
            this.category.fileId = this.filesId
            this.$vs.loading();
            this.$crm.post(`/school-quiz-category/update/${this.params.data.id}`,this.category).then((response) => {
                this.$vs.loading.close();
                this.popupActiveUse = false;
                this.$store.commit('DELETE_CATEGORY', true)
                return this.$vs.notify({
                    text: 'Cập nhật danh mục thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmDeleteCategory(){
            this.$vs.dialog({
                type:'confirm',
                color:'danger',
                title: 'Xác nhận xoá',
                text:`Bạn có chắc là muốn xoá danh mục "${this.params.data.categoryName}" không? `,
                accept: this.deleteCategory,
                acceptText:'Xoá',
                cancelText:'Huỷ',
            })
        },
        deleteCategory() {
            this.$vs.loading();
            this.$crm.post(`/school-quiz-category/delete/${this.params.data.id}`).then((response) => {
                this.$vs.loading.close();
                this.$store.commit('DELETE_CATEGORY', true)
                return this.$vs.notify({
                    text: 'Xóa danh mục thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

    mounted() {
        this.$eventBus.$on('', () => {
            this.$store.commit('DELETE_CATEGORY', true)
        })
    }
    },
}
</script>
<style scoped>

.required::after {
    content: '* ';
    color: red;
}

</style>
